import { useRef } from 'react';
import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { useLayout } from '../../../hooks/screen/useLayout';
import { CreateOwnTractorButton } from './components/CreateOwnTractorButton';
import { useGetDownloadAppModalHeight } from '../../../hooks/modal/useGetDownloadAppModalHeight';
import { TabContainer } from '../../../components/common/tab/TabContainer';
import { PublishedTractorListSection } from './components/PublishedTractorListSection';
import { UnpublishedTractorListSection } from './components/UnpublishedTractorListSection';
import { ampli } from '../../../ampli';

type TabContainerRef = {
  selectTab: (index: number) => void;
};

export const MyInfoOwnTractorListPage = () => {
  const tabContainerRef = useRef<TabContainerRef | null>(null);

  const changeOwnTractorsTab = (index: number) => {
    if (tabContainerRef) {
      tabContainerRef.current?.selectTab(index);
    }
  };

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} headerTitle={'보유 트랙터 관리'} />,
    fixedHeaderHeight: 48,
    fixedFooter: <CreateOwnTractorButton />,
    fixedFooterHeight: 52,
  });

  const downloadAppModalHeight = useGetDownloadAppModalHeight();

  return (
    <Container>
      <TabContainer
        ref={tabContainerRef}
        style={{
          width: 'calc(100% - 32px)',
          transform: 'translateX(16px)',
          position: 'sticky',
          top: `${40 + downloadAppModalHeight}px`,
          zIndex: 50,
          backgroundColor: 'white',
        }}
        tabInfos={[
          {
            text: '찔러보기 받는 중',
            element: <PublishedTractorListSection changeTabIndex={changeOwnTractorsTab} />,
            handleTabClick: () => {
              ampli.pvmClickMyOwnPublishedTab();
            },
          },
          {
            text: '찔러보기 안 받는 중',
            element: <UnpublishedTractorListSection changeTabIndex={changeOwnTractorsTab} />,
            handleTabClick: () => {
              ampli.pvmClickMyOwnUnpublishedTab();
            },
          },
        ]}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`;
